import React from 'react';
import ReactPlayer from 'react-player';
import './VideoPlayer.scss';

const VideoPlayer = ({ src, loop = false, is16than9 = true }) => {
  return (
    <div className={is16than9 ? 'player-wrapper' : ''}>
      <ReactPlayer
        className={is16than9 ? 'react-player' : ''}
        url={src}
        width="100%"
        height="100%"
        controls
        playing
        muted
        loop={loop}
      />
    </div>
  );
};

export default VideoPlayer;
